import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ManagerReportsDetailPage } from './manager-reports-detail.page';

const routes: Routes = [
  {
    path: '',
    component: ManagerReportsDetailPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManagerReportsDetailPageRoutingModule {}
